import { useRef } from "react";
import images from "../images/images.js";
import { HeadLogo } from "../components/headLogo.jsx";
import howToPlaySteps from "../data/stepInfo.js";

function HomeDesktopView({ onStartClick, onAboutus }) {
  const introRef = useRef(null);

  function handleLearnMoreClickACB() {
    introRef.current?.scrollIntoView({ behavior: "smooth" });
  }

  return (
    <div className="home-container">
      <img
        src={images.heroImage}
        alt="Map"
        className="homeView-hero_illustration"
      />

      {/* Welcome Section */}
      
      <div className="homeView-welcome_sectiond">
        <div className="home_header">
        <div className="home_title">
          Welcome to</div>
          <br /> 
          <div className="logoType">stad.hunt</div>
        
        <HeadLogo /></div>

        <div className="homeView-cta-buttons">
          <button className="home-main-btn" onClick={onStartClick}>
            Let’s Hunt!
          </button>
          <button
            className="home-main-btn inverse"
            onClick={handleLearnMoreClickACB}
          >
            Learn More
          </button>
        </div>
      </div>

      {/* Intro Text */}
      <section className="homeView-welcome_section-intro_text" ref={introRef}>
        <div className="home-section-title">
          Discover Stockholm through a treasure hunt!
        </div>
        <div className="global-body_text">
          Stad Hunt Stockholm turns the city into your game board. Follow clues,
          solve riddles, and unlock the hidden stories behind iconic landmarks.
          Learn how these places connect to other famous sites around the world
          and even what life was like in your home country when they were built.
        </div>
      </section>

      {/* How to Play Steps */}
      <section className="homeView-howtoplay">
        <div className="home-section-title">How to Play</div>
        <div className="home-steps">
          {howToPlaySteps.map((step, index) => (
            <div key={index} className="home-step">
              <img
                src={images[step.img]}
                alt={step.alt}
                className="homeView-howtoplay_img"
              />
              <div>
                <div className="home-stepSubtitle">{step.title}</div>
                <div className="global-body_text">{step.description}</div>
              </div>
            </div>
          ))}
        </div>

        {/* Final CTA */}
        <section className="homeView-cta-buttons">
          <button className="home-main-btn" onClick={onStartClick}>
            Let’s Hunt!
          </button>
          <button className="home-main-btn inverse" onClick={onAboutus}>
            About Us
          </button>
        </section>
      </section>
    </div>
  );
}

export { HomeDesktopView };
